import React from 'react';
import { makeStyles } from '@material-ui/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Link, useCurrentRoute } from 'react-navi';
import Button from '@material-ui/core/Button';
import config from '../config';
import styled from 'styled-components';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import MUILink from '@material-ui/core/Link';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const Logo = styled(Link)`
    width: ${({ mobile }) => (mobile ? 155 : 309.61499999999995)}px;
    height: ${({ mobile }) => (mobile ? 75 : 150)}px;
    background-image: url(${config.baseV1Url}/img/TextCafe_logo.png);
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    display: block;
`;

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    // link: {
    //     color: '#fff'
    // },
    // linkButton: {
    //     color: '#fff',
    //     textDecoration: 'none'
    // },
    flex: {
        display: 'flex',
        alignItems: 'center',
    },
    button: {
        height: '50px',
        fontWeight: '700',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));

function TopNav({ isAuthenticationStateKnown, currentUser, mobile }) {
    const {
        url: { pathname },
    } = useCurrentRoute();
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [aboutOpen, setAboutOpen] = React.useState(false);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const open = Boolean(anchorEl);

    const toggleAbout = () => {
        setAboutOpen(!aboutOpen);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLogout = () => {
        window.location = config.logoutUrl;
    };
    const handleLogin = () => {
        window.location = config.loginUrl;
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const isAdmin = currentUser && currentUser.role === 'admin';
    const isPublisher = currentUser && currentUser.role === 'publisher';
    return (
        <div className={classes.root}>
            <AppBar elevation={0} position="relative">
                {!mobile && (
                    <Toolbar className={classes.toolbar}>
                        <div className={classes.flex}>
                            <Logo
                                href={config.baseV1Url}
                                className={classes.link}
                            />
                            {(isPublisher || isAdmin) && (
                                <Button
                                    className={classes.button}
                                    href="/jobs/add"
                                >
                                    UPLOAD
                                </Button>
                            )}
                            {currentUser && (<Button
                                className={classes.button}
                                color={
                                    pathname.includes('catalog')
                                        ? 'primary'
                                        : 'default'
                                }
                                href="/v2/catalog"
                            >
                                CATALOG
                            </Button>)}
                            {currentUser && (<Button
                                className={classes.button}
                                color={
                                    pathname.includes('marketing')
                                        ? 'primary'
                                        : 'default'
                                }
                                href="/v2/marketing"
                            >
                                MARKETING
                            </Button>)}
                            {isAdmin && (
                                <Button
                                    href="/publishers"
                                    color={
                                        pathname.includes('admin')
                                            ? 'primary'
                                            : 'default'
                                    }
                                    className={classes.button}
                                >
                                    ADMIN
                                </Button>
                            )}
                            {currentUser && (<Button
                                className={classes.button}
                                href="/job_preferences"
                            >
                                PREFERENCES
                            </Button>)}
                        </div>
                        {currentUser ? (
                            <div className={classes.flex}>
                                <Button onClick={handleMenu}>
                                    {currentUser.username}
                                </Button>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <MenuItem>
                                        <a href="/account">Account</a>
                                    </MenuItem>
                                    <MenuItem onClick={handleLogout}>
                                        Logout
                                    </MenuItem>
                                </Menu>
                            </div>
                        ) : (
                            <Button onClick={handleLogin}>Login</Button>
                        )}
                    </Toolbar>
                )}
                {mobile && (
                    <Toolbar className={classes.toolbar}>
                        <Logo
                            mobile={'true'}
                            href={config.baseV1Url}
                            className={classes.link}
                        />
                        <IconButton
                            aria-label="Filter list"
                            onClick={toggleMenu}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Toolbar>
                )}
            </AppBar>
            {mobile && (
                <Drawer anchor="top" open={menuOpen} onClose={toggleMenu}>
                    <List>
                        <ListItem
                            button
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                            onClick={toggleMenu}
                        >
                            <CloseIcon />
                        </ListItem>
                        {(isPublisher || isAdmin) && (
                            <MUILink href="/jobs/add">
                                <ListItem button>
                                    <ListItemText primary={'UPLOAD'} />
                                </ListItem>
                            </MUILink>
                        )}
                        {currentUser && (<MUILink href="/v2/catalog">
                            <ListItem
                                button
                                selected={pathname.includes('catalog')}
                            >
                                <ListItemText primary={'CATALOG'} />
                            </ListItem>
                        </MUILink>)}
                        {currentUser && (<MUILink href="/v2/marketing">
                            <ListItem
                                button
                                selected={pathname.includes('marketing')}
                            >
                                <ListItemText primary={'MARKETING'} />
                            </ListItem>
                        </MUILink>)}
                        <Divider />
                        {isAdmin && (
                            <MUILink href="/publishers">
                                <ListItem
                                    button
                                    selected={pathname.includes('admin')}
                                >
                                    <ListItemText primary={'ADMIN'} />
                                </ListItem>
                            </MUILink>
                        )}
                        {isAdmin && (
                            <MUILink href="/job_preferences">
                                <ListItem button>
                                    <ListItemText primary={'PREFERENCES'} />
                                </ListItem>
                            </MUILink>
                        )}
                        <Divider />
                        {currentUser && (
                            <MUILink href="/account">
                                <ListItem button>
                                    <ListItemText primary={'ACCOUNT'} />
                                </ListItem>
                            </MUILink>
                        )}
                        {currentUser && (
                            <MUILink href="/logout">
                                <ListItem button>
                                    <ListItemText primary={'SIGN OUT'} />
                                </ListItem>
                            </MUILink>
                        )}
                        <Divider />
                        <ListItem button onClick={toggleAbout}>
                            <ListItemText primary="ABOUT" />
                            {aboutOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={aboutOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {[
                                    {
                                        value: 'Sell More Books',
                                        link: '/',
                                    },
                                    {
                                        value: 'Our Mission',
                                        link: '/about#mission',
                                    },
                                    {
                                        value: 'Our Team',
                                        link: '/about#team',
                                    },
                                    {
                                        value: 'News',
                                        link: '/about#news',
                                    },
                                ].map((item, index) => (
                                    <MUILink key={index} href={item.link}>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                        >
                                            <ListItemText
                                                primary={item.value}
                                            />
                                        </ListItem>
                                    </MUILink>
                                ))}
                            </List>
                        </Collapse>
                    </List>
                </Drawer>
            )}
        </div>
    );
}
/*
      li!= linkTo('Sell More Books', '/')
      li!= linkTo('Our Mission', '/about#mission')
      li!= linkTo('Our Team', '/about#team')
      li!= linkTo('News', '/about#news')

* */
export default TopNav;
